import { inject, injectable } from "@launchtray/tsyringe-async";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { Viewable } from "../../../../../scene/viewable/Viewable";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { ILogger } from "by/gamefactory/cityversetycoon/logger/ILogger";
import { MyWalletPopupView } from "../views/MyWalletPopupView";
import { MyWalletResourcePackage } from "../resources/MyWalletResourcePackage";
import { Web3Model } from "by/gamefactory/web3/models/Web3Model";
import { IMyWalletController } from "../controllers/IMyWalletController";
import { IMyWalletModel } from "../model/IMyWalletModel";
import { UserProfileResourcePackage } from "../../userprofile/resources/UserProfileResourcePackage";
import { IGuestModel } from "../../../common/models/IGuestModel";
import { IInventory } from "../../../../../web3/models/IInventory";
import { AsyncOperationNotification } from "../../../common/components/AsyncOperationNotification";
import { IPlayerModel } from "../../../common/models/IPlayerModel";
import { MyWalletPopupSceneOptions } from "./MyWalletPopupSceneOptions";
import { Web3Config } from "../../../../../web3/config/Web3Config";
import { GameInfo } from "../../../../../analytics/GameInfo";

@injectable()
export class MyWalletPopupScene extends Viewable<void> {
    public constructor(
        commonResources: CommonResourcesPackage,
        myWallerResources: MyWalletResourcePackage,
        userProfileResources: UserProfileResourcePackage,
        @inject("ICanvasScaler") canvasScaler: ICanvasScaler,
        @inject("ILogger") logger: ILogger,
        @inject("IMyWalletController") myWalletController: IMyWalletController,
        web3Model: Web3Model,
        web3Config: Web3Config,
        @inject("IMyWalletModel") myWalletModel: IMyWalletModel,
        @inject("IGuestModel") guestModel: IGuestModel,
        @inject("IPlayerModel") playerModel: IPlayerModel,
        @inject("IInventory") inventory: IInventory,
        asyncOperationNotification: AsyncOperationNotification,
        @inject("MyWalletPopupSceneOptions") options: MyWalletPopupSceneOptions,
        gameInfo: GameInfo
    ) {
        super();
        const pcs = new PromiseCompletionSource<void>();
        this.view = new MyWalletPopupView(
            pcs,
            canvasScaler,
            commonResources,
            myWallerResources,
            options.buildingResources,
            options.piggyClubResources,
            userProfileResources,
            web3Model,
            myWalletModel,
            web3Config,
            myWalletController,
            inventory,
            logger,
            guestModel,
            options.forceTab,
            asyncOperationNotification,
            playerModel,
            gameInfo
        );
        pcs.result.then(() => {
            this.operationControls.complete();
            userProfileResources.destroy();
        }, (reason: unknown) => {
            this.operationControls.error(reason);
        });
    }
}
